import styled from "styled-components";

interface IMainProps {
  page: number;
}

const translateParams = [0, -100, -200, -280];

export const Main = styled.div`
  height: 100vh;
  width: 380vw;
  display: flex;
  transform: ${({ page }: IMainProps) =>
    `translateX(${translateParams[page]}vw)`};
  transition: all 1s ease-in-out;

  .colored-box {
    width: 272vw;
    height: calc(100vh - 100px);
    margin-top: 100px;
    background-color: rgba(100, 100, 200, 0.5);
    margin-left: 18vw;
    display: flex;
  }
`;
